/**
 * Demo mode: use the app without API / login for frontend-only testing.
 * Enable only via localStorage.demoMode = 'true' (e.g. from a "Try demo" action or dev tools).
 * Works on any local port (e.g. 3000, 3001); no dependency on a specific port.
 */

const DEMO_STORAGE_KEY = 'demoMode';
const DEMO_TOKEN = 'demo';
const DEMO_USER_ID = '1';

export function isDemoMode() {
  return typeof localStorage !== 'undefined' && localStorage.getItem(DEMO_STORAGE_KEY) === 'true';
}

export function setDemoMode(enabled) {
  if (typeof localStorage === 'undefined') return;
  if (enabled) {
    localStorage.setItem(DEMO_STORAGE_KEY, 'true');
  } else {
    localStorage.removeItem(DEMO_STORAGE_KEY);
  }
}

/**
 * Set cookies so existing code that reads user_token / userId sees a valid "user".
 * Call when entering demo mode (e.g. from SignIn or Dashboard).
 */
export function setDemoCookies() {
  if (typeof document === 'undefined') return;
  const expires = new Date();
  expires.setDate(expires.getDate() + 60);
  document.cookie = `user_token=${DEMO_TOKEN}; path=/; expires=${expires.toUTCString()}`;
  document.cookie = `userId=${DEMO_USER_ID}; path=/; expires=${expires.toUTCString()}`;
}

/**
 * Store minimal data so Dashboard and other pages that read from localStorage don't break.
 */
export function setDemoLocalStorage() {
  if (typeof localStorage === 'undefined') return;
  const teamId = '1';
  const assignedMemberRole = {
    [teamId]: [
      {
        team_name: 'Demo Team',
        competences: { role: 'manager', salaried: 'salaried', manager: 'manager' },
        ConfirmationDate: '15',
      },
    ],
  };
  localStorage.setItem('userId', DEMO_USER_ID);
  localStorage.setItem('teams_and_competences', JSON.stringify({
    assignedMembercompetences: assignedMemberRole,
  }));
  localStorage.setItem('selected_team', teamId);
}

/**
 * Call on app load when demo mode is on: ensure cookies and localStorage are set
 * so the user is treated as "logged in".
 */
export function ensureDemoSession() {
  if (!isDemoMode()) return;
  setDemoCookies();
  setDemoLocalStorage();
}
